/* global axios */
import ApiClient from '../ApiClient';

// T-254: a quebra de Tempo de atendimento por causa raiz, com categoria, CSAT e SLA.
class CausaRaizQuebraAPI extends ApiClient {
  constructor() {
    super('fandata/causa_raiz_quebra', { accountScoped: true });
  }

  get({ since, until } = {}) {
    return axios.get(this.url, { params: { since, until } });
  }
}

export default new CausaRaizQuebraAPI();
